import React, { FC } from 'react';
import clsx from 'clsx';
import SizedBox from './SizedBox';
import { Colors } from './@types';

type TypographyTag = 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'p' | 'b' | 'i' | 'span' | 'small' | 'time';

interface TextComponentProps {
  align?: 'center' | 'right' | 'left';
  appearance?: 'p' | 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'h7' | 'h8' | 'h9' | 'link' | 'small';
  bold?: boolean;
  breakWord?: boolean;
  className?: string;
  color?: Colors;
  ellipsis?: boolean;
  inline?: boolean;
  lineClamp?: 2 | 3 | 4 | 5 | 6;
  normal?: boolean;
  spaced?: boolean;
  noWrap?: boolean;
  tooltip?: string;
  tiny?: boolean;
  underline?: boolean;
  uppercase?: boolean;
  variant?: 'title' | 'subtitle' | undefined;
  tag?: TypographyTag;
}

const Typography: FC<TextComponentProps> = ({
  align,
  appearance,
  color = 'inherit',
  lineClamp,
  variant,
  bold = false,
  ellipsis = false,
  breakWord = false,
  underline = false,
  spaced = false,
  normal = false,
  uppercase = false,
  noWrap = false,
  tiny,
  children,
  className,
  tag = 'span',
  tooltip,
  inline = false,
}) => {
  const Tag = tag;

  const cls = {
    'text-spaced': spaced,
    'text-normal': normal,
    'text-bold': bold,
    'text-uppercase': uppercase,
    'text-break': breakWord,
    'text-underline': underline,
    'text-ellipsis': ellipsis,
    'text-nowrap': noWrap,
    tiny,
  };

  const alignCls = align ? `text-align-${align}` : '';
  const lineClampCls = lineClamp ? `line-clamp-${lineClamp}` : '';
  const colorCls = color ? `color-${color}` : '';

  return (
    <SizedBox
      className={className}
      title={tooltip}
      display={inline ? 'inline-block' : undefined}
      maxWidth={ellipsis ? '100%' : undefined}
    >
      <Tag className={clsx(cls, alignCls, colorCls, lineClampCls, variant, appearance)}>
        {children}
      </Tag>
    </SizedBox>
  );
};

export default Typography;
